import { createFileRoute, redirect } from '@tanstack/react-router'
import { assertCanPlayBeforeLoad } from '@/features/ctrls-and-caps/assert-can-play-before-load'

export const Route = createFileRoute('/_app/your-play/gameplay-limits')({
  beforeLoad: async ({ search, matches, context }) => {
    await assertCanPlayBeforeLoad(context.queryClient)

    // only on exact match on this route, not the child
    if (matches.at(-1)?.id === Route.id) {
      throw redirect({ to: '/your-play/gameplay-limits/all', search })
    }
  },
})
